import React, { useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import '../assets/css/dialpad.css'
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone,faArrowLeft,faBackspace } from '@fortawesome/free-solid-svg-icons'; // Import the icon for the clear button
import Comtemplete from './comtemplete';
import { setshowcalllogpage } from '../redux/backgroundpermission/permission-action';


const Dialpad = (props) => {
  const {showDial, setShowDial} = props;
  const [dial, setDial] = useState('')
  const setDialFun = (number) => {
    
    const num = dial + '' + number
    setDial(num)

  }

  const dialcall = () => {
     let data ={
       
         number:dial
     }
    window.postMessage({  type:'Manual', data: data });

  }

  const slicenumber = () => {
    setDial(dial.slice(0, -1));
  }
  
  const handleInputChange = (e) => {
    const value = e.target.value;
    // Allow only digits and * or #
    if(showDial){
      props.handleDial(value);
    }
    if (/^[0-9#*]*$/.test(value)) {
      setDial(value);
    }else {
        // Optionally show an error or prevent invalid characters
        e.target.value = dial; // Reset to last valid value
    }
  };

  const handleChange = (value) =>{
    try {
      if(showDial){
        props.handleDial(value)
      }
      setDialFun(value)
      
    } catch (error) {
      console.log(error)
    }
  } 


  return (
    
      <div className="dialpad">
        <div className='pad-shownumber'>
          <Form.Control
            type="text"
            value={dial}
            className="pad"
            onChange={handleInputChange}
          />
        </div>
        <div className="dialpad_sub_container">



          <div className="dialnumber">
            <div className='dialpad_raper'>
              <span className='dialpad_number' onClick={() => handleChange(1)}>1</span>
              <span className='dialpad_number' onClick={() => handleChange(2)}>2</span>
              <span className='dialpad_number' onClick={() => handleChange(3)}>3</span>
            </div>
            <div className='dialpad_raper'>
              <span className='dialpad_number' onClick={() => handleChange(4)}>4</span>
              <span className='dialpad_number' onClick={() => handleChange(5)}>5</span>
              <span className='dialpad_number' onClick={() => handleChange(6)}>6</span>
            </div>
            <div className='dialpad_raper'>
              <span className='dialpad_number' onClick={() => handleChange(7)}>7</span>
              <span className='dialpad_number' onClick={() => handleChange(8)}>8</span>
              <span className='dialpad_number' onClick={() => handleChange(9)}>9</span>
            </div>
            <div className={  'dialpad_raper'}>
            {showDial === true &&<span className='dialpad_number' onClick={() => handleChange("*")}>*</span>}
              <span className='dialpad_number' onClick={() => handleChange(0)}>0</span>
              {showDial === true && <span className='dialpad_number' onClick={() => handleChange("#")}>#</span>}
            </div>
            {showDial !== true&&<div className='dialpad_raper'>
              
                <button className="call-button" onClick={dialcall} disabled={dial.length < 5}>
                  <FontAwesomeIcon style={{ color: '#fff', fontSize: '15px', textAlign: 'center',cursor:'pointer'}} icon={faPhone} />
                </button>
            

              <div >
                
                <FontAwesomeIcon style={{ color: '#3498db', fontSize: '15px',cursor:"pointer" }} icon={faBackspace} onClick={slicenumber} />
              </div>


            </div>}


          </div>
          <div>



          </div>
        </div>
      </div>
     
   
  )

};

export default Dialpad;










